import { Component } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-cell-checkbox',
  templateUrl: './cell-checkbox.component.html',
  styleUrls: ['./cell-checkbox.component.less']
})
export class CellCheckboxComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }
}
